import i18next from 'i18next';

const frTranslations = require('../../public/locales/fr.json');

i18next.init({
    lng: 'fr',
    resources: { fr: { translation: frTranslations }}
});

export default i18next;